import { LabMDM } from "./lab";
import { Template } from './template';

//This model is used to define the lab printer properties
export class Printer {
    _id: string;

    /** The lab where the printer is located. */
    lab:LabMDM;

	/** The printer name. */
	name:string ;

    /** Printer description */
    description:string;

    /** The ip address of the physical printer. */
    hostAddress:string;

    /** The port of the physical printer. */
    port:number;

    printEnabled:boolean;

    defaultPrinter:boolean;
	
    active:boolean;

    template:Template;
}